import { handleActions } from "redux-actions";
import { GENERIC_FILTERS } from "constants/action-types";

export interface IState {
    error?: Error;
    isFetching: boolean;
    results: string[];
}

export const initialState: IState = {
    isFetching: false,
    results: [],
};

export const genericFilters = handleActions<IState, any>(
    {
        [GENERIC_FILTERS.FETCH.START]: (state: IState) => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [GENERIC_FILTERS.FETCH.SUCCESS]: (state: IState, { error, payload }: any) => {
            if (error) {
                return {
                    ...state,
                    error,
                };
            }
            return {
                ...state,
                isFetching: false,
                results: payload,
            };
        },
        [GENERIC_FILTERS.RESET]: () => initialState,
    },
    initialState
);
